<script setup lang="ts">
import AdminUserTableFilters from '@/views/AdministrationView/AdminUserTableFilters.vue'
import { type UserProviderType, EProviders } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'

provide<UserProviderType>(EProviders.USER, { UserTableFilters: AdminUserTableFilters })
</script>

<template>
    <slot />
</template>
